<template>
  <v-card>
    <gg-toolbar @close="closeModal">
      Delete filter
    </gg-toolbar>

    <v-card-text>
      Are you sure you wish to delete the “{{ filtername }}” filter?
    </v-card-text>

    <v-card-actions>
      <gg-btn color="primary"
             tile
             elevation="0"
             :disabled="loading"
             :loading="loading"
             @click="removeFilter">
        Delete
      </gg-btn>
      <gg-btn color="primary" text="text" @click="closeModal">
        Close
      </gg-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteModal',
  data: () => ({
    loading: false
  }),
  props: {
    account: {
      type: String
    },
    filtername: {
      type: String
    }
  },
  methods: {
    ...mapActions({
      deleteFilter: 'email/deleteFilter',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    async removeFilter () {
      this.loading = true
      const data = {
        uapi_module: 'Email',
        uapi_function: 'delete_filter',
        account: this.account,
        filtername: this.filtername,
        _username: this.$route.query.user,
      }
      try {
        await this.deleteFilter(data, this.account)

        this.loading = false
        this.closeModal()
        this.reportSuccess('Filter successfully deleted')
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    closeModal () {
      this.$emit('close')
    },
  }
}
</script>
